import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import t from '../../../lib/I18n';
import BaseModal from '../../general/BaseModal';
import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';

const AmazonRegisterFirstModal = ({ onClose, onContinue}) => {
    const modalProps = {
        className: 'modal--xs',
        closeText: t('login.registerFirst.closeText'),
        continueText: t('login.registerFirst.continueText'),
        onClose,
        onContinue,
        titleText: t('login.registerFirst.title')
    };

    return (<BaseModal { ...modalProps }>
        <section>
            <div className="text-center">
                <p>
                    <FormattedHTMLMessage message="login.registerFirst.message" accountType={ t('app.owner.short') } />
                </p>
            </div>
        </section>
    </BaseModal>);
};

AmazonRegisterFirstModal.propTypes = {
    onClose: PropTypes.func,
    onContinue: PropTypes.func
};

AmazonRegisterFirstModal.defaultProps = {
    onClose: _.noop,
    onContinue: _.noop
};

export default AmazonRegisterFirstModal;



// WEBPACK FOOTER //
// ./src/components/login/amazon/AmazonRegisterFirstModal.js